export default __webpack_public_path__ + "static/media/fasad4.0848c2ab.jpeg";